import React, {useState, useEffect} from 'react';
import moment from 'moment';

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

import useDateInterval from '../../hooks/useDateInterval';
import {ReportHeader, ReportTable} from '../../components/Tables/Report';
import PrintButton from '../../components/Buttons/PrintButton';
import {withData} from '../../containers/DataContainer';
import {makeReportData} from '../../libs/report';
import printDocument from '../../libs/printLib';
import useStyles from '../styles';

const View = ({
  fetchDeliveriesByDate,
}) => {

  const classes = useStyles();

  const [data, setData] = useState([]);
  const [isBusy, setBusy] = useState(true);
  const [startDate, setStartDate, endDate, setEndDate] = useDateInterval({
    startDate: moment().startOf('day'),
    endDate: moment().endOf('day')
  });

  useEffect(() => {
    const fetchData = async () => {
      setBusy(true);
      const deliveries = await fetchDeliveriesByDate({
        startDate: '' + startDate.valueOf(),
        endDate: '' + Math.max(endDate.valueOf(), startDate.valueOf())
      })
      const data = makeReportData(deliveries);
      setData(data);
      setBusy(false);
    };
    fetchData();
  }, [
    fetchDeliveriesByDate,
    startDate,
    endDate,
    setBusy
  ]);

  const onPrint = printDocument('relatorio.pdf','reportTable');

  return <Paper className={classes.paper}>
    <Grid container>
      <Grid item xs={12}>
        <ReportHeader
          {...{startDate, setStartDate, endDate, setEndDate}}
        />
      </Grid>
      <Grid item>
        <PrintButton onClick={onPrint}/>
      </Grid>
      <Grid item xs={12}>
        <ReportTable
          {...{
            data,
            startDate,
            endDate,
            isBusy
          }}
        />
      </Grid>
    </Grid>
  </Paper>;
};

export default withData(View);
